import React, { useState } from "react";
import { motion } from "framer-motion";
import { Copy, Check, Menu, X } from "lucide-react";
import { toast } from "sonner";
import { CONTRACT_ADDRESS, BUY_URL, X_URL, MASCOT_IMG, copyText } from "../../data/constants";

const LINKS = [
  { label: "The Lore", href: "#lore" },
  { label: "Outbreak Map", href: "#globe" },
  { label: "Live News", href: "#news" },
  { label: "Diagnose Me", href: "#diagnose" },
];

export const Navbar = () => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const copyCA = async () => {
    const ok = await copyText(CONTRACT_ADDRESS);
    if (ok) {
      setCopied(true);
      toast.success("Contract copied to your grubby hands", { description: "Now go infect your wallet." });
      setTimeout(() => setCopied(false), 1600);
    } else {
      toast("Couldn't auto-copy", { description: CONTRACT_ADDRESS });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-40" data-testid="navbar">
      <div className="petri mx-2 md:mx-4 mt-2 md:mt-3 px-3 md:px-5 py-2 flex items-center justify-between gap-2 rounded-none">
        <a href="#top" className="flex items-center gap-2 group shrink-0" data-testid="nav-logo">
          <motion.img
            src={MASCOT_IMG}
            alt="Cyclospora logo"
            className="w-9 h-9 md:w-12 md:h-12 drop-shadow-[2px_2px_0_#0a133f]"
            animate={{ rotate: [0, -8, 8, 0] }}
            transition={{ duration: 2.4, repeat: Infinity }}
          />
          <span className="stencil text-lg md:text-2xl leading-none">CYCLO$PORA</span>
        </a>

        <div className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              className="font-mono2 text-sm uppercase tracking-widest text-white/80 hover:text-[#d9b3ff] transition-colors glitch-hover"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={copyCA}
            data-testid="nav-copy-ca"
            className="hidden xl:flex items-center gap-2 font-mono2 text-xs bg-[#0a133f] border-2 border-[#b026ff] px-3 py-2 hover-shake"
          >
            {copied ? <Check size={14} className="text-[#d9b3ff]" /> : <Copy size={14} className="text-[#b026ff]" />}
            <span className="text-white/70">{CONTRACT_ADDRESS.slice(0, 4)}...{CONTRACT_ADDRESS.slice(-4)}</span>
          </button>
          <a
            href={X_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-x-btn"
            className="hidden sm:flex btn-hazard bg-white text-[#0a133f] w-9 h-9 md:w-10 md:h-10 items-center justify-center text-base md:text-lg"
            aria-label="X community"
          >
            X
          </a>
          <a
            href={BUY_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-buy-btn"
            className="btn-hazard bg-[#d9b3ff] text-[#0a133f] px-3 md:px-5 py-2 text-sm md:text-base pulse-glow"
          >
            <span className="sm:hidden">BUY</span>
            <span className="hidden sm:inline">BUY $CYCLOSPORA</span>
          </a>
          <button className="lg:hidden text-white p-1" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden petri mx-2 mt-2 p-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="font-mono2 uppercase tracking-widest text-white/80 hover:text-[#d9b3ff]">
              {l.label}
            </a>
          ))}
          <a href={X_URL} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="font-mono2 uppercase tracking-widest text-white/80 hover:text-[#d9b3ff]">
            X Community
          </a>
          <button
            onClick={() => { copyCA(); setOpen(false); }}
            data-testid="nav-mobile-copy-ca"
            className="flex items-center gap-2 font-mono2 text-xs bg-[#0a133f] border-2 border-[#b026ff] px-3 py-2 text-left"
          >
            <Copy size={14} className="text-[#b026ff] shrink-0" />
            <span className="text-white/70 break-all">{CONTRACT_ADDRESS}</span>
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
